import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, FileSignature } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { SignaturZeile, OFFEN } from '../signaturen/SignaturZeile';

export const useOffeneSignaturen = () => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get('/admin/esign').then((r) => setItems((r.data.items || []).filter((v) => OFFEN.includes(v.status) || v.status === 'signiert'))).catch(() => setItems([])), []);
  useEffect(() => { load(); window.addEventListener('signaturen-geaendert', load); return () => window.removeEventListener('signaturen-geaendert', load); }, [load]);
  return [items, load];
};

export const signaturenGeaendert = () => window.dispatchEvent(new Event('signaturen-geaendert'));

// Kanzleiweit offene E-Signaturen – direkt erinnern oder zurückziehen
export const OffeneSignaturen = ({ onCount }) => {
  const [items, load] = useOffeneSignaturen();
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (items) onCount?.(items.length); }, [items, onCount]);
  const onAction = async (v, art) => {
    if (art === 'zurueck' && !window.confirm('Signaturanfrage zurückziehen? Der Link wird ungültig.')) return;
    setBusy(true);
    try {
      await (art === 'erinnern' ? api.post(`/admin/esign/${v.vorgang_id}/senden`) : api.patch(`/admin/esign/${v.vorgang_id}/stornieren`));
      toast.success(art === 'erinnern' ? 'Erinnerung gesendet' : 'Zurückgezogen'); signaturenGeaendert();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Aktion fehlgeschlagen'); }
    setBusy(false);
  };
  if (!items) return <div className="flex justify-center py-16"><Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" /></div>;
  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-testid="m360-offene-signaturen">
      {items.length === 0 ? <p className="p-10 text-center text-sm text-gray-500"><FileSignature className="w-7 h-7 mx-auto mb-2 text-[#b8893d]" />Keine offenen Signaturanfragen.</p>
        : <ul className="divide-y divide-gray-100">{items.map((v) => <SignaturZeile key={v.vorgang_id} v={v} onAction={onAction} busy={busy} />)}</ul>}
    </div>
  );
};

export default OffeneSignaturen;
